import * as Long from "long";
import * as React from "react";
import { IdTooltipAdjust } from "../../../constants/IdTooltipAdjust";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { utilShop } from "../../../utils/utilShop";
import { Badge } from "../../generic/badge/Badge";
import { IdBadgePosition } from "../../generic/badge/IdBadgePosition";
import { ButtonInfoSmall } from "../../generic/common/ButtonInfoSmall";
import { componentWithProps } from "../../generic/componentWithProps";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../../generic/number-format/TypeNumberFormat";
import { TextLoca } from "../../generic/text/TextLoca";
import { DynamicTooltip, IdTooltipAnchor } from "../../tooltip";
import { IdOfferType } from "../IdOfferType";
import { OfferBadgeWebBonus } from "./OfferBadgeWebBonus";
import { OfferGoldRewardTooltip } from "./OfferGoldRewardTooltip";
export var OfferRewardsHeader = function (props) {
    var baseGoldValue = props.baseGoldValue, bonusGoldValue = props.bonusGoldValue, rewards = props.rewards, primeTimeBonus = props.primeTimeBonus, subscriptionBonus = props.subscriptionBonus, type = props.type, _a = props.idTooltipAnchor, idTooltipAnchor = _a === void 0 ? IdTooltipAnchor.Right : _a, webBonusGold = props.webBonusGold, _b = props.isPurchased, isPurchased = _b === void 0 ? false : _b;
    var bonusGoldReplacements = new Map([
        [ReplacementLoca.zero_0, utilNumber.format(bonusGoldValue || 0)],
    ]);
    var hasSubscriptionBuff = subscriptionBonus && subscriptionBonus.gt(Long.ZERO);
    var headerFontStyle = hasSubscriptionBuff ? IdStyles.HeadlineAccent : IdStyles.HeadlineOne;
    var adjustHorizontal = idTooltipAnchor === IdTooltipAnchor.Left ? -295 : -IdTooltipAdjust.Small;
    var totalGoldAmount = utilShop.calculateOfferTotalGoldAmount({
        baseGoldValue: Long.fromValue(baseGoldValue) || Long.ZERO,
        primeTimeBonus: Long.fromValue(primeTimeBonus || 0),
        rewards: rewards,
        subscriptionBonus: subscriptionBonus || Long.ZERO,
        webBonusGold: webBonusGold,
    });
    var bonusGoldComponent;
    var idLocaWebBonus = IdLoca.goldSum_includeWebBonus;
    if (bonusGoldValue && bonusGoldValue > 0) {
        bonusGoldComponent = (React.createElement(TextLoca, { id: IdLoca.goldSum_contentWorth, replacements: bonusGoldReplacements, className: IdStyles.TextNormal }));
    }
    if (type === IdOfferType.HCOffer && !isPurchased) {
        totalGoldAmount = Long.fromValue(baseGoldValue).add(subscriptionBonus || Long.ZERO);
        idLocaWebBonus = IdLoca.exclusiveGold_web;
    }
    var tooltipComponent = componentWithProps({
        ComponentType: OfferGoldRewardTooltip,
        offer: props,
    });
    return (React.createElement(DynamicTooltip, { component: tooltipComponent, anchor: idTooltipAnchor, adjustHorizontal: adjustHorizontal, adjustVertical: -15, visibleOnClick: true, shouldRender: type !== IdOfferType.HCOffer || isPurchased },
        React.createElement("div", { className: IdStyles.OfferDetailsHeader + " offer-body__rewards-container pos-rel" },
            (type !== IdOfferType.HCOffer || isPurchased) && (React.createElement(Badge, { position: IdBadgePosition.TopLeft },
                React.createElement(ButtonInfoSmall, null,
                    React.createElement(Icon, { icon: IdIcon.InfoIcn, styleId: IdStyles.IconSmall })))),
            React.createElement(Icon, { icon: IdIcon.GoldIcn, styleId: IdStyles.IconLarge }),
            React.createElement("div", { className: "offer-body__rewards-header-text" },
                totalGoldAmount.greaterThan(Long.ZERO) && (React.createElement("div", null,
                    React.createElement(NumberFormat, { className: headerFontStyle, format: TypeNumberFormat.None, amount: totalGoldAmount }))),
                bonusGoldComponent),
            React.createElement(Badge, { position: IdBadgePosition.TopRight },
                React.createElement(OfferBadgeWebBonus, { bonusGold: webBonusGold, className: "offer-body__bonus--large", idLoca: idLocaWebBonus })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferRewardsHeader.tsx
// module id = 2913
// module chunks = 3